// @ts-nocheck
import checkoutShippingReducer, {
    StoreCheckoutShippingActions,
} from "@store/Framework/Store/Store/Pages/CheckoutShipping/CheckoutShippingReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    checkoutShipping: checkoutShippingReducer,
};

export type StorePagesActions = StoreCheckoutShippingActions;
export default combineReducers(pagesReducers);
